import React, { useMemo, useEffect, useRef } from 'react';
import { svgSprite, Img } from '../../../../../hybrid/wrappers';
import { t } from '../../../../../common/components/T';
import { rankColors } from '../../../../../project/uikit/data-variables/rank-colors';
import Display from '../../../../../common/components/Display';
import css from './UserInfoBlock.module.scss';
import classnames from 'classnames';
import { generateCompStylers } from '../../../../../common/utils/styles';

const UserInfoBlock = ({ data, translation, compStyle }) => {
    const contactsItems = data.contacts;
    const previewCanvasRef = useRef(null);
    const imgRef = useRef(null);
    const dataArr = useMemo(() => (contactsItems ? Object.keys(contactsItems) : []), [contactsItems]);
    const rankData = useMemo(() => data?.rank || data?.marketing_profile?.rank, [data]);
    const rankColor = useMemo(() => {
        if (rankData) {
            return rankColors[rankData?.sort] || rankColors[rankColors.length - 1];
        }
        return rankColors[0];
    }, [rankData]);
    const isDropdown = useMemo(() => {
        const res = [];
        dataArr.map((item) => {
            if (contactsItems[item] !== null) {
                res.push(contactsItems[item]);
            }
        });
        return res.length > 0;
    }, [contactsItems, dataArr]);
    const ContactImg = (val) => {
        switch (val) {
            case 'email':
                return 'email-colored';
            case 'phone':
                return 'phone-colored';
            case 'facebook':
                return 'facebook-colored';
            case 'instagram':
                return 'instagram-colored';
            case 'ok':
                return 'odnoklassniki-colored';
            case 'telegram':
                return 'telegram-colored';
            case 'twitter':
                return 'twitter-colored';
            case 'viber':
                return 'viber-colored';
            case 'vk':
                return 'vkontakte-colored';
            case 'whatsapp':
                return 'whatsapp-colored';
            default:
                return 'phone';
        }
    };
    useEffect(() => {
        if (!previewCanvasRef.current || !imgRef.current) {
            return;
        }
        const image = imgRef.current;
        const canvas = previewCanvasRef.current;
        const crop = {};
        const scaleX = image.naturalWidth / image.width;
        const scaleY = image.naturalHeight / image.height;
        const ctx = canvas.getContext('2d');
        const pixelRatio = window.devicePixelRatio;
        canvas.width = crop.width * pixelRatio;
        canvas.height = crop.height * pixelRatio;
        ctx.setTransform(pixelRatio, 0, 0, pixelRatio, 0, 0);
        ctx.imageSmoothingQuality = 'high';
        ctx.drawImage(
            image,
            crop.x * scaleX,
            crop.y * scaleY,
            crop.width * scaleX,
            crop.height * scaleY,
            0,
            0,
            crop.width,
            crop.height
        );
    }, []);
    const { stylers, classes } = generateCompStylers(compStyle);

    return (
        <div style={{ width: '100%', ...stylers.wrapper }} className={classnames(css.formGroupBlockWeb, classes.wrapper)}>
            <>
                <div className={css.formUserBlockWrapper}>
                    <div className={css.formUserBlock}>
                        <div className={css.formUserBlockImg}>
                            <div></div>
                            <div>
                                <div
                                    style={{
                                        zIndex: '0',
                                        position: 'relative'
                                    }}
                                >
                                    {!!data?.image?.links?.preview ? (
                                        <Img
                                            style={{
                                                'object-fit': 'cover',
                                                'border-radius': '50%'
                                            }}
                                            className={classnames(css.formUserAvatarImg)}
                                            src={data?.image?.links?.preview}
                                        />
                                    ) : (
                                        svgSprite('plug-user-image', {
                                            className: css.formUserAvatarImg
                                        })
                                    )}
                                    <canvas ref={previewCanvasRef} className={css.formUserAvatarCanvas} />
                                </div>
                            </div>
                            <p
                                style={{ background: rankColor.gradient }}
                                className={classnames(css.formUserPosition, css.formUserPositionWeb)}
                            >
                                {!!rankData ? rankData.name : t('Form-NoRank', 'Без ранга', 'widget', translation, 'form')}
                            </p>
                        </div>
                        <div>
                            <p className={css.formUserSubtitle}>
                                {data?.full_name ? data.full_name : <Display type='fio' data={data} />}
                            </p>
                            <div className={css.formUserLogin}>
                                <div className={css.formUserLoginIconWrap}>
                                    {svgSprite('user-circle-fill', {
                                        className: css.formUserLoginIcon
                                    })}
                                </div>
                                <p className={css.formUserLoginText}>{data.username}</p>
                            </div>
                            <div className={classnames(css.flexRow, css.aligndatasCenter)}>
                                <p
                                    className={classnames(
                                        css.formUserLoginText,
                                        css.formUserLoginTextMR,
                                        css.formUserLoginTextLabel
                                    )}
                                >
                                    {t('Form-package', 'Пакет', 'widget', translation, 'form')}:
                                </p>
                                <p className={css.formUserLoginText}>
                                    {data?.marketing_profile?.package
                                        ? data?.marketing_profile?.package.name
                                        : t('Form-package-no', 'Без пакета', 'widget', translation, 'form')}
                                </p>
                            </div>
                        </div>
                    </div>
                    {!!isDropdown && (
                        <div className={css.formUserContactBlock}>
                            {dataArr.map((contactItem, idx) => {
                                if (data.contacts && data.contacts[contactItem] !== null) {
                                    return (
                                        <div className={css.formUserContactItem} key={`${data.username}${idx}`}>
                                            {svgSprite(ContactImg(contactItem), {
                                                className: css.formUserContactItemIcon
                                            })}
                                            <p>{`${data.contacts[contactItem]}`}</p>
                                        </div>
                                    );
                                }
                            })}
                        </div>
                    )}
                </div>
            </>
        </div>
    );
};
export default UserInfoBlock;
